import React from 'react';
import Particles from 'react-particles-js';
import {
    Form, Input, Button, message
} from 'antd';
import {login} from "../action/login_action";

import {
    LockOutlined,
    UserOutlined
} from '@ant-design/icons';

class ComponentLogin extends React.Component{

    static STATE_STRUCT = () => {
        return {
            loginLoading: false,
        }
    };

    state = ComponentLogin.STATE_STRUCT();

    render(){
        return (
            <Form className="login-form" onFinish={(values)=>{
                this.setState({loginLoading: true});
                login(values.userName, values.passWord, (res, msg) => {
                    this.setState({loginLoading: false});
                   if (res) {
                       localStorage.isLogin = true;
                       this.props.history.push("/");
                   }
                   else
                       message.error(msg ? msg : "登录失败!");
                });
            }} style={{paddingTop:'60px'}}>
                <div style={{backgroundColor:'white', padding: '15px', borderRadius: '4px', width:'468px', textAlign:'center', margin: '0 auto'}}>
                    <Form.Item name="userName" rules={[{ required: true, message: '请输入用户名!' }]} style={{marginTop: 20}}>
                        <Input style={{width: "100%"}} prefix={<UserOutlined />} placeholder="用户名" />
                    </Form.Item>
                    <Form.Item name="passWord" rules={[{ required: true, message: '请输入密码!' }]} style={{marginTop: 20}}>
                        <Input style={{width: "100%"}} prefix={<LockOutlined />} type="password" placeholder="密码" />
                    </Form.Item>
                    <Button style={{width: '100%', marginTop: 20}} type="primary" htmlType="submit" className="login-form-button" loading={this.state.loginLoading}>
                        登录
                    </Button>
                </div>
            </Form>
        )
    }
}

class Login extends React.Component{
    static STATE_STRUCT = () => {
        return {

        }
    };

    state = Login.STATE_STRUCT();

    render() {
        return (
            <div style={{textAlign: 'center'}}>
                <ComponentLogin history={this.props.history} />
                <Particles ref='particle'
                   params={{
                       particles: {
                           number: {
                               value: 130
                           }
                       },
                   }}
                   style={{margin: '0', top:'0', left:'0', position: 'fixed', width: '100%', height: '100%', zIndex:'-1', backgroundColor: '#1872E1'}} />
            </div>
        );
    }
}

export default Login;
